import React from 'react'
import {Icon} from '@chakra-ui/react'

const GiftIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.47037 6C3.26049 5.53475 3.16121 5.01006 3.18921 4.45006C3.28497 2.53497 4.84552 1 7.00046 1C8.72234 1 10.1822 2.12297 11.4447 3.92654C11.6669 4.2439 11.8747 4.57186 12.0681 4.90466C12.2515 4.57545 12.4502 4.25102 12.6644 3.93681C13.8966 2.12891 15.3849 1 17.1848 1C19.2605 1 20.7963 2.53856 20.9258 4.43172C20.9646 4.99866 20.8743 5.52971 20.6709 6H23V12H22V24H2V12H1V6H3.47037ZM7.0004 6H10.3908C10.2096 5.68234 10.0142 5.37067 9.80617 5.07346C8.88116 3.75203 7.90352 3 7.0004 3C5.92618 3 5.2299 3.68486 5.18665 4.54994C5.14453 5.39244 5.74196 6 7.0004 6ZM13.748 6H17.1846C18.429 6 18.9881 5.41308 18.9303 4.56828C18.8705 3.69495 18.1768 3 17.1846 3C16.1981 3 15.2144 3.74609 14.3168 5.06319C14.1121 5.36343 13.9222 5.67869 13.748 6ZM3 10H11V8H3V10ZM13 8V10H21V8H13ZM4 12V22H11V12H4ZM13 12V22H20V12H13Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default GiftIcon
